import { useEffect, useState } from 'react';

/** `value`, once it has stopped changing for `delayMs` — so a search box does not query on every keystroke. */
export const useDebouncedValue = <TValue>(value: TValue, delayMs = 250): TValue => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);

    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
